<template lang="html">
  <i-btn
    color="error"
    icon="mdi-close-circle"
    @click="$emit('click', $event)"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  }
}
</script>

<style lang="css" scoped>
</style>
